import AdminLoginForm from './AdminLoginForm';

export default AdminLoginForm;
